const getUniqueTimeStampId = (prefix) => {
    const uniqueId = new Date().getTime();
    return (prefix || "") + uniqueId;
};

export { getUniqueTimeStampId };
